import { createTheme } from '@mui/material/styles';

// Color palette from the image
const colors = {
  midnightNavy: '#0B1229',
  pacificTeal: '#1C7C73',
  sandStone: '#EAFADE',
  coralAccent: '#FF7A59', // Main coral color
  offWhite: '#FAF9FB',
  inkBlack: '#0F0F14',
  mint: '#7ECDB0',
  skyGray: '#90E2E2',
  electricCyan: '#2DA4FD'
};

export const theme = createTheme({
  palette: {
    primary: {
      main: colors.coralAccent, // Coral as primary
      light: '#FF9F85',
      dark: '#E55A3C',
      contrastText: '#ffffff',
    },
    secondary: {
      main: colors.pacificTeal,
      light: '#4A9B94',
      dark: '#135750',
      contrastText: '#ffffff',
    },
    background: {
      default: colors.offWhite,
      paper: '#ffffff',
    },
    text: {
      primary: colors.inkBlack,
      secondary: colors.midnightNavy,
    },
    success: {
      main: colors.mint,
      light: '#A6E0C4',
      dark: '#5BB896',
    },
    info: {
      main: colors.electricCyan,
      light: '#5AB7FD',
      dark: '#1F85D1',
    },
    warning: {
      main: colors.skyGray,
      light: '#B3EDED',
      dark: '#6BCECE',
    },
    error: {
      main: '#f44336',
      light: '#e57373',
      dark: '#d32f2f',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.125rem',
      lineHeight: 1.2,
      color: colors.inkBlack,
    },
    h2: {
      fontWeight: 600,
      fontSize: '1.75rem',
      lineHeight: 1.3,
      color: colors.inkBlack,
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: 1.4,
      color: colors.inkBlack,
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: 1.4,
      color: colors.inkBlack,
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.125rem',
      lineHeight: 1.4,
      color: colors.inkBlack,
    },
    h6: {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: 1.4,
      color: colors.inkBlack,
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
      color: colors.midnightNavy,
    },
    body2: {
      fontSize: '0.75rem',
      lineHeight: 1.5,
      color: colors.midnightNavy,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
          padding: '8px 24px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 2px 8px rgba(255, 122, 89, 0.3)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
          border: `1px solid ${colors.offWhite}`,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: colors.inkBlack,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: colors.midnightNavy,
          color: '#ffffff',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          margin: '2px 8px',
          '&.Mui-selected': {
            backgroundColor: colors.coralAccent,
            color: '#ffffff',
            '&:hover': {
              backgroundColor: colors.coralAccent,
            },
          },
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
        colorPrimary: {
          backgroundColor: colors.coralAccent,
          color: '#ffffff',
        },
        colorSecondary: {
          backgroundColor: colors.mint,
          color: colors.inkBlack,
        },
      },
    },
  },
});

export default theme;